import { createAxios } from '../lib/axiosFactory';
import { dataCollectionParser } from '../lib/response/dataParser';

export const state = (): Record<string, unknown> => ({
  templates: []
});

export const getters = {
  goals: (state): Array<string> => {
    return Object.keys(
      state.templates.reduce((result, x) => {
        for (const goal of x.goals) {
          result[goal] = true;
        }
        return result;
      }, {})
    ).sort();
  }
};

export const mutations = {
  setTemplates(state, templates: Record<string, unknown>[]): void {
    state.templates = templates;
  }
};

export const actions = {
  async loadTemplates(
    context: any,
    { objective }: { objective: string }
  ): Promise<void> {
    try {
      const response = await createAxios().get('/backend/templates-index', {
        params: {
          objective: objective
        }
      });

      context.commit('setTemplates', dataCollectionParser(response));
    } catch (error) {
      context.commit('setTemplates', []);
    }
  }
};
